import { createSlice } from '@reduxjs/toolkit'

const {
  actions: {
    getUIConfigStart,
    getUIConfigSuccess,
    getUIConfigFailure,
    setGeneralConfig
  },
  reducer
} = createSlice({
  name: 'ui-config',
  initialState: {
    loading: false,
    general: null,
    homePage: null,
    accounts: null
  },
  reducers: {
    getUIConfigStart: (state) => ({
      ...state,
      loading: true
    }),
    // Allows setting tenant general config early without waiting for components-config
    setGeneralConfig: (state, { payload }) => ({
      ...state,
      general: payload
    }),
    getUIConfigSuccess: (state, { payload }) => ({
      ...state,
      loading: false,
      general: payload?.general,
      homePage: payload?.homePage,
      accounts: payload?.accounts
    }),
    getUIConfigFailure: (state) => ({
      ...state,
      loading: false
    })
  }
})

export default reducer

export {
  getUIConfigStart,
  getUIConfigSuccess,
  getUIConfigFailure,
  setGeneralConfig
}
